import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, useRef, createElement } from 'react';
import cn from 'classnames';
import { IconButton } from '../IconButton/IconButton.js';
import { PopoverDisclosure, Popover } from 'reakit/Popover';
import { Input } from '../Input/Input.js';
import { ScrollableList } from '../Listbox/ScrollableList.js';
import { useCombobox } from './useCombobox.js';
import { useBoundingClientRectListener } from '../../utils/hooks/useBoundingClientRectListener.js';

var _excluded = ["className", "style"],
    _excluded2 = ["container"];
var Combobox = /*#__PURE__*/forwardRef(function Combobox(props, ref) {
  var externalClassName = props.className,
      style = props.style,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var _useCombobox = useCombobox(otherProps, ref),
      combobox = _useCombobox.combobox,
      input = _useCombobox.input,
      popover = _useCombobox.popover,
      list = _useCombobox.list;

  var container = popover.container,
      base = _objectWithoutPropertiesLoose(popover, _excluded2);

  var internalRef = useRef(null);
  var selectDimensions = useBoundingClientRectListener(internalRef);
  var className = cn('yt-combobox', {
    'yt-combobox--inline': props.inline
  }, externalClassName);
  return createElement("span", {
    className: className,
    style: style
  }, createElement(PopoverDisclosure, Object.assign({}, base, {
    ref: internalRef
  }), function (_ref) {
    var ref = _ref.ref;
    return createElement("span", Object.assign({}, combobox, {
      ref: ref
    }), createElement(Input, Object.assign({}, input, {
      autoComplete: "off",
      button: props.inline ? createElement(IconButton, {
        icon: popover.visible ? 'chevron-up' : 'chevron-down',
        onClick: popover.toggle,
        tabIndex: -1
      }) : props.button
    })));
  }), !otherProps.disabled && createElement(Popover, Object.assign({}, base, container), createElement(ScrollableList, Object.assign({}, list, {
    className: "w-auto",
    style: {
      minWidth: selectDimensions === null || selectDimensions === void 0 ? void 0 : selectDimensions.width
    },
    tabIndex: popover.visible ? 0 : -1
  }))));
});

export { Combobox };
//# sourceMappingURL=Combobox.js.map
